"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _TransmuteCollection = require("./TransmuteCollection");

_TransmuteCollection.sortBy.implement(Array, function (getSortValue, arr) {
  return (0, _immutable.Seq)(arr).sortBy(getSortValue).toArray();
});

_TransmuteCollection.sortBy.implementInherited(_immutable.Iterable, function (getSortValue, subject) {
  return subject.sortBy(getSortValue);
});

_TransmuteCollection.sortBy.implement(Object, function (getSortValue, obj) {
  return (0, _immutable.Seq)(obj).sortBy(getSortValue).toObject();
});

var _default = _TransmuteCollection.sortBy;
exports.default = _default;
module.exports = exports.default;